import { ProductResponse } from 'core'

import { Col, Row } from 'common/components'

type Props = {
  product: ProductResponse
}

const ProductDetails = (pros: Props) => {
  return (
    <Row data-testid={'product-details'} gutter={16}>
      <Col data-testid={'product-details-charge-ineligibleAdmins'}>
        <b>Charge Ineligible Admins</b>: {pros.product.chargeIneligibleAdmins ? 'Yes' : 'No'}
      </Col>

      <Col data-testid={'product-details-minimum-seats'}>
        <b>Minimum Seats</b>: {pros.product.minimumSeats}
      </Col>
    </Row>
  )
}

export default ProductDetails
